import { useMemo } from 'react';

// Put initialState into a getter
export const useStoreOptions = (initialState: any, isPageSSRd: boolean): any =>
	useMemo(() => {
		if (initialState && isPageSSRd) {
			return {
				storeOptions: {
					initialState,
				},
			};
		} else {
			return {};
		}
	}, [initialState, isPageSSRd]);
